import { render, staticRenderFns } from "./open.vue?vue&type=template&id=fcd54c10&scoped=true&"
import script from "./open.vue?vue&type=script&lang=js&"
export * from "./open.vue?vue&type=script&lang=js&"
import style0 from "./open.vue?vue&type=style&index=0&id=fcd54c10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd54c10",
  null
  
)

export default component.exports